"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const DropdownForm_1 = __importDefault(require("@App/kit/fields/DropdownForm"));
const CountryCode = (props) => (react_1.default.createElement("div", { className: "phone-country-code" },
    react_1.default.createElement(DropdownForm_1.default, Object.assign({}, props))));
exports.default = CountryCode;
